import Marquee from "react-fast-marquee";

const ITEMS = [
  "Heritage",
  "Honest Rates",
  "Tranquility",
  "Heart of Varanasi",
  "Kashi Vishwanath",
  "Family-Run",
  "Ganga at Dawn",
  "Thatheri Bazar",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-white/5 bg-[#0b0b0d] py-8">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="mx-12 flex items-center gap-12 md:mx-20 md:gap-20">
          <span className="font-serif text-2xl font-light italic text-[#F5F5F0]/35 md:text-3xl">
            {item}
          </span>
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-[#C5A059]/60" />
        </span>
      ))}
    </Marquee>
  </div>
);
